module.exports = __webpack_public_path__ + "img/revolucionCanina2.e4ed2d38.jpg";